import { render, staticRenderFns } from "./BusinessPlans.vue?vue&type=template&id=39799e08"
import script from "./BusinessPlans.vue?vue&type=script&lang=js"
export * from "./BusinessPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports